import { authStore } from "./authStore";
import { commonStore } from "./commonStore";
import { notificationStore } from "./notificationStore";
import { userStore } from "./userStore";
import { productStore } from "./productStore";
import { serviceStore } from "./serviceStore";
import { useContext } from "react";
import { MobXProviderContext } from "mobx-react";

export { AuthStore } from "./authStore";
export { CommonStore } from "./commonStore";
export { NotificationStore } from "./notificationStore";
export { UserStore } from "./userStore";
export { ServiceStore } from "./serviceStore";
export { ProductStore } from "./productStore";

export const stores = {
  authStore,
  commonStore,
  notificationStore,
  userStore,
  productStore,
  serviceStore,
} as const;

export type Stores = typeof stores;

export function useStores() {
  return useContext<Stores>(MobXProviderContext as any);
}

export {
  READY,
  LOADING,
  ERROR,
  STALE,
  NOT_INITIATED,
  NO_PROJECTS,
} from "./constants";
